
import { IDS } from "./pnp-settings-compliance-report.constants";


export const pnpSettingsComplianceReportState = {
    name: IDS.app_policies_settings_compliance_report,
    redirectTo: IDS.app_policies_settings_compliance_report_listing,
    url: '/compliance-report',
    component: 'tabs'
};

export const pnpSettingsComplianceReportListingState = {
    name: IDS.app_policies_settings_compliance_report_listing,
    url: '',
    component: IDS.pnpComplianceReportGrid
};
